import { axiosLegoBricks } from "./axios.service";

export class AlternateSetService {

    public delete = async (id: number) => {
		const response = await axiosLegoBricks().delete(`/AlternateSet/${id}`);
		return response.data;
	}
}